module.exports = __webpack_public_path__ + "static/media/chatLoader.cf176650.gif";